import { AccuserAppealModel } from "src/app/core/view-models/appeal-judgement";

export const AccuserAppealListMock: AccuserAppealModel = {
    filingAs:[
        {
            id:1,
            seq:1,
            groupId:1,
            checked:false
        },
        {
            id:2,
            seq:2,
            groupId:1,
            checked:false
        },
        {
            id:3,
            seq:1,
            groupId:2,
            checked:false
        }
    ]


}